'use client';

import { BoxButton, Description, InfoView } from '@repo/ui';
import Link from 'next/link';
import { usePathname, useRouter } from 'next/navigation';
import React from 'react';
import { ErrorBoundary, FallbackProps } from 'react-error-boundary';

import { LogoLayout } from '@/app/_components/layout-content/Layouts';

export const GlobalErrorBoundary = ({ children }: { children: React.ReactNode }) => {
  const pathname = usePathname();
  return (
    <ErrorBoundary key={pathname} FallbackComponent={DefaultFallbackComponent}>
      {children}
    </ErrorBoundary>
  );
};

export const DefaultFallbackComponent = ({ error }: FallbackProps) => {
  const router = useRouter();
  const errorMessage = (error as Error)?.message;

  return (
    <LogoLayout>
      <InfoView
        description={
          <Description
            size={'medium'}
            graphic={
              <img src={`${process.env.NEXT_PUBLIC_RESOURCE_CENTER_URL}/icons/icg_laptop-question-mark_lg.svg`} width={80} height={80} alt="Not Found Icon" />
            }
            title={'에러가 발생했어요'}
            description={errorMessage ?? '알 수 없는 에러가 발생했어요. 잠시 후 다시 시도해주세요.'}
            button={
              <Link href={'/'}>
                <BoxButton
                  variant={'filled-primary'}
                  size={'medium'}
                  onClick={() => {
                    router.replace('/');
                  }}
                >
                  홈으로 돌아가기
                </BoxButton>
              </Link>
            }
          />
        }
      />
    </LogoLayout>
  );
};
